import { all, put, takeLatest } from 'redux-saga/effects';
import {
  LOAD_COMPANY_LIST,
  LOAD_COMPANY_LIST_FAILED,
  RENDER_COMPANY_LIST,
  ADD_NEW_COMPANY,
  ADD_NEW_COMPANY_SUCCESS,
  ADD_NEW_COMPANY_FAILED,
  COMPANY_VALIDATION_FAILED,
  UPDATE_COMPANY,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAILED,
  DELETE_COMPANY,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAILED,
  LIMIT_ERROR,
} from '../actions/CompanyActions';

import {
  ADD_NEW_COMPANY_FOR_USER,
  ADD_NEW_COMPANY_FOR_USER_SUCCESS,
  ADD_NEW_COMPANY_FOR_USER_FAILED,
  ADD_NEW_COMPANY_FOR_USER_VALIDATION_FAILED,
} from '../actions/createCompanyForUserAction';

import { ACTIVE_COMPANY_NOT_FOUND } from '../actions/SigninActions';

import { TOKEN_ERROR, ACCESS_REMOVED } from '../actions/index';

import { defaultApi } from '../utils/axiosApi';

export function* fetchCompanyList(credentials) {
  const creds = credentials.credentials || {};
  const perPage = creds.per_page || 10;
  const page = creds.page || 1;
  const search = creds.search
    ? `&search=${encodeURIComponent(creds.search)}`
    : '';
  const endpoint = `${process.env.REACT_APP_API_BASE_URL}/company?page=${page}&per_page=${perPage}${search}`;

  const { response, error } = yield defaultApi(
    endpoint,
    'GET',
    undefined,
    true
  );

  if (response) {
    const { data } = response;

    yield put({
      type: RENDER_COMPANY_LIST,
      currentPage: data.data && data.data.current_page,
      totalPage: data.data && data.data.total_page,
      total: data.data && data.data.total,
      companyList: data.data && data.data.companyList,
      roles: data.data && data.data.roles,
    });
  }
  if (error) {
    const { data } = error;
    if (data.status === 'Token_error') {
      yield put({
        type: TOKEN_ERROR,
        message: data.message,
      });
    } else if (data.status === 'company-not-found') {
      yield put({
        type: ACTIVE_COMPANY_NOT_FOUND,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'access-removed') {
      yield put({
        type: ACCESS_REMOVED,
        message: data.message,
        data: data.data,
      });
    } else {
      yield put({
        type: LOAD_COMPANY_LIST_FAILED,
        message: data.message,
      });
    }
  }
}

export function* saveNewCompany(credentials) {
  const base = process.env.REACT_APP_API_BASE_URL;
  const endpoint = `${base}/company`;
  const credentials2 = credentials.credentials;
  const { response, error } = yield defaultApi(
    endpoint,
    'POST',
    credentials2,
    true
  );
  if (response) {
    const { data } = response;
    // Profiles come from /me (single source of truth), not the create response.
    const me = yield defaultApi(`${base}/user/me`, 'GET', undefined, true);
    const d = (me.response && me.response.data && me.response.data.data) || {};
    yield put({
      type: ADD_NEW_COMPANY_SUCCESS,
      message: data.message,
      allProfile: d.allProfiles,
      activeProfile: d.activeProfile,
    });
  }
  if (error) {
    const { data } = error;
    if (data.status === 'Token_error') {
      yield put({
        type: TOKEN_ERROR,
        message: data.message,
      });
    } else if (data.status === 'company-not-found') {
      yield put({
        type: ACTIVE_COMPANY_NOT_FOUND,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'access-removed') {
      yield put({
        type: ACCESS_REMOVED,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'limit_error') {
      yield put({
        type: LIMIT_ERROR,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'validation_error') {
      yield put({
        type: COMPANY_VALIDATION_FAILED,
        message: data.message,
        errors: data.data,
      });
    } else {
      yield put({
        type: ADD_NEW_COMPANY_FOR_USER_FAILED,
        message: data.message,
      });
    }
  }
}

export function* addNewCompanyForUser(credentials) {
  const endpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/createForUser`;
  const credentials2 = credentials.credentials;
  const { response, error } = yield defaultApi(
    endpoint,
    'POST',
    credentials2,
    true
  );
  if (response) {
    const company = response.data.data; // { id, name, ... } — id is a stringified bigint
    if (company && company.id) {
      localStorage.setItem('active_company_id', company.id);
    }
    const base = process.env.REACT_APP_API_BASE_URL;
    const me = yield defaultApi(`${base}/user/me`, 'GET', undefined, true);
    if (me.response && me.response.data && me.response.data.data) {
      const d = me.response.data.data;
      yield put({
        type: ADD_NEW_COMPANY_FOR_USER_SUCCESS,
        message: response.data.message || 'Company created',
        allProfiles: d.allProfiles,
        activeProfile: d.activeProfile,
        loggedInAccountType: d.loggedInAccountType,
        user: d.user,
        token: localStorage.getItem('access_token'),
      });
    } else {
      yield put({
        type: ADD_NEW_COMPANY_FOR_USER_FAILED,
        message: 'Unexpected server response',
      });
    }
  }
  if (error) {
    const { data } = error;
    if (data.status === 'Token_error') {
      yield put({
        type: TOKEN_ERROR,
        message: data.message,
      });
    } else if (data.status === 'company-not-found') {
      yield put({
        type: ACTIVE_COMPANY_NOT_FOUND,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'access-removed') {
      yield put({
        type: ACCESS_REMOVED,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'validation_error') {
      yield put({
        type: ADD_NEW_COMPANY_FOR_USER_VALIDATION_FAILED,
        message: data.message,
        errors: data.data,
      });
    } else {
      yield put({
        type: ADD_NEW_COMPANY_FAILED,
        message: data.message,
      });
    }
  }
}
export function* updateUserCompany(credentials) {
  const base = process.env.REACT_APP_API_BASE_URL;
  const credentials2 = credentials.credentials;
  const endpoint = `${base}/company/${credentials2.id}`;
  const { response, error } = yield defaultApi(
    endpoint,
    'PUT',
    { name: credentials2.name, status: credentials2.status },
    true
  );
  if (response) {
    const { data } = response;
    // Profiles come from /me (single source of truth), not the update response.
    const me = yield defaultApi(`${base}/user/me`, 'GET', undefined, true);
    const d = (me.response && me.response.data && me.response.data.data) || {};
    yield put({
      type: UPDATE_COMPANY_SUCCESS,
      message: data.message,
      allProfile: d.allProfiles,
      activeProfile: d.activeProfile,
    });
  }
  if (error) {
    const { data } = error;
    if (data.status === 'Token_error') {
      yield put({
        type: TOKEN_ERROR,
        message: data.message,
      });
    } else if (data.status === 'company-not-found') {
      yield put({
        type: ACTIVE_COMPANY_NOT_FOUND,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'access-removed') {
      yield put({
        type: ACCESS_REMOVED,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'validation_error') {
      yield put({
        type: COMPANY_VALIDATION_FAILED,
        message: data.message,
        errors: data.data,
      });
    } else {
      yield put({
        type: UPDATE_COMPANY_FAILED,
        message: data.message,
      });
    }
  }
}

export function* deleteUserCompany(credentials) {
  const base = process.env.REACT_APP_API_BASE_URL;
  const credentials2 = credentials.credentials;
  const endpoint = `${base}/company/${credentials2.id}`;
  const { response, error } = yield defaultApi(
    endpoint,
    'DELETE',
    undefined,
    true
  );
  if (response) {
    const { data } = response;
    // Profiles come from /me (single source of truth), not the delete response.
    const me = yield defaultApi(`${base}/user/me`, 'GET', undefined, true);
    const d = (me.response && me.response.data && me.response.data.data) || {};
    yield put({
      type: DELETE_COMPANY_SUCCESS,
      message: data.message,
      allProfile: d.allProfiles,
    });
  }
  if (error) {
    const { data } = error;
    if (data.status === 'Token_error') {
      yield put({
        type: TOKEN_ERROR,
        message: data.message,
      });
    } else if (data.status === 'company-not-found') {
      yield put({
        type: ACTIVE_COMPANY_NOT_FOUND,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'access-removed') {
      yield put({
        type: ACCESS_REMOVED,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'validation_error') {
      yield put({
        type: COMPANY_VALIDATION_FAILED,
        message: data.message,
        errors: data.data,
      });
    } else {
      yield put({
        type: DELETE_COMPANY_FAILED,
        message: data.message,
      });
    }
  }
}

export function* companyList() {
  yield takeLatest(LOAD_COMPANY_LIST, fetchCompanyList);
}
export function* addNewCompany() {
  yield takeLatest(ADD_NEW_COMPANY, saveNewCompany);
}

export function* createNewCompanyForUser() {
  yield takeLatest(ADD_NEW_COMPANY_FOR_USER, addNewCompanyForUser);
}

export function* updateCompany() {
  yield takeLatest(UPDATE_COMPANY, updateUserCompany);
}
export function* deleteCompany() {
  yield takeLatest(DELETE_COMPANY, deleteUserCompany);
}

export default function* rootSaga() {
  yield all([
    companyList(),
    addNewCompany(),
    updateCompany(),
    deleteCompany(),
    createNewCompanyForUser(),
  ]);
}
